import React, { useEffect } from "react";
import AcademyHomeComponent from "../../../components/academy/academy-home";
import { trackEvent } from "../../../analytics";

function Academy() {
  const isPageViewTracked = React.useRef(false);

  useEffect(() => {
    if (isPageViewTracked.current) return;
    trackEvent("academy_opened", {});
    isPageViewTracked.current = true;
  }, []);
  return <AcademyHomeComponent />;
}

export default Academy;
